import { Component } from "solid-js";

import styles from "bundle-text:../styles/_selectorCard.scss";

interface SelectorCardProps {
  icon: string;
  bgColor: string;
  title: string;
  text: string;
  active?: boolean;
  selected?: boolean;
  onSelect?: () => void;
}

const SelectorCard: Component<SelectorCardProps> = (props) => {
  return (
    <>
      <style>{styles}</style>
      <div
        class="selector-card"
        classList={{ inactive: !props.active, selected: props.selected }}
        onClick={props.onSelect}
      >
        <div>
          <img
            class="icon"
            src={props.icon}
            style={{ background: props.bgColor }}
          />
          <span class="title">{props.title}</span>
        </div>
        <p class="text">{props.text}</p>
      </div>
    </>
  );
};

export default SelectorCard;
